module.exports = __webpack_public_path__ + "static/media/om_beard_tailored_diamond__v.d5704dbf.png";